// Lightweight SEO helper for the SPA — sets title + meta/og tags per page.
// Modern crawlers render JS, so this is picked up for indexing.
const SITE = "AVX Pro";

function setMeta(attr, key, content) {
    if (!content) return;
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

function setCanonical(url) {
    if (!url) return;
    let el = document.head.querySelector('link[rel="canonical"]');
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", "canonical");
        document.head.appendChild(el);
    }
    el.setAttribute("href", url);
}

export function setJsonLd(data, id = "seo-jsonld") {
    let el = document.getElementById(id);
    if (!el) {
        el = document.createElement("script");
        el.type = "application/ld+json";
        el.id = id;
        document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
}

export function setSeo({ title, description, image, canonical } = {}) {
    const fullTitle = title ? `${title} · ${SITE}` : SITE;
    document.title = fullTitle;
    setMeta("name", "description", description);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    if (image) setMeta("property", "og:image", image);
    setMeta("name", "twitter:card", "summary_large_image");
    const url = canonical || (typeof window !== "undefined" ? window.location.href : "");
    setMeta("property", "og:url", url);
    setCanonical(url);
}
